import React, { useState, useContext } from 'react';

import { CustomizeContext } from '../contexts/customize';

import cautionImg from '../../assets/caution.png';

const MtmConfirm = ({onClickConfirm}) => {
  const [popup, setPopup] = useState(false);
  const [error, setError] = useState([]);
  const { customizes } = useContext(CustomizeContext);

  const mtmBodyType = document.getElementById('mtm-customize').dataset.mtmBodyType;

  const clickConfirm = () => {
    let confirmCheck = true;
    let errorItem = [];
    for (let item in customizes) {
      if (item == 'sizes') {
        for (let size in customizes[item]) {
          if (size !== 'cuffs_width_left' && size !== 'cuffs_width_right' && size !== 'waist_size' && size !== 'yoke_size' && size !== 'sleeve_width') {
            if (customizes[item][size].id == '') {
              confirmCheck = false;
              errorItem.push(item + '-' + size);
            }
          }
        }
      } else if (item == 'embroideryOptions') {
        const emb = customizes.embroideryOptions || {};
        const isEmb = emb.embroidery?.value;
        if (isEmb === undefined) {
          confirmCheck = false;
          errorItem.push(item);
          continue;
        }
        if (!isEmb) {
          continue;
        }
        if (!emb.embroidery_color?.value) {
          confirmCheck = false;
          errorItem.push(item + '-embroidery_color');
        }
        if (!emb.embroidery_type?.value) {
          confirmCheck = false;
          errorItem.push(item + '-embroidery_type');
        }
        if (!emb.embroidery_place?.value) {
          confirmCheck = false;
          errorItem.push(item + '-embroidery_place');
        }
        if (!emb.embroidery_format?.value) {
          confirmCheck = false;
          errorItem.push(item + '-embroidery_format');
        }
        const initialText = (emb.embroidery_initial?.value || '').split('.').join('');
        if (!initialText.length) {
          confirmCheck = false;
          errorItem.push(item + '-embroidery_initial');
        }
      } else if (item == 'brand_name' || item == 'kamakura_name') {
        continue;
      } else if (item == 'pocket' && mtmBodyType == 'formal'){
        continue;
      } else {
        if (customizes[item].id == '') {
          confirmCheck = false;
          errorItem.push(item);
        }
      }
    }

    if (confirmCheck) {
      // チェック完了
      document.getElementById('mtm-customize').classList.add('confirm');
      document.getElementById('mtm-timeline').classList.add('none');
      document.getElementById('mtm-header').classList.add('none');
      document.getElementById('onClickConfirm').click();
    } else {
      // エラー
      setPopup(true);
      setError(errorItem);
    }
  }

  const closePopup = () => {
    setPopup(false);
  }

  return (
    <>
      <div className="mtm-item__wrapper mtm-confirm" id="mtm-confirm">
        <p> Once you've change your selections, some selections may reset.</p>
        <div className="selects-item__detail_button">
          <button className="mtm-confirm_btn" onClick={clickConfirm}>Confirm</button>
          <button id="onClickConfirm" hidden onClick={onClickConfirm}></button>
        </div>
      </div>
      {popup && (
        <div className="confirmError popup_error">
          <div className="popup_error_bg" onClick={closePopup}></div>
          <div className="popup_error_content">
            <div className="popup_error_close" onClick={closePopup}></div>
            <div className="popup_error_heading">
              <img src={cautionImg} />
              <p>Caution</p>
            </div>
            <div className="popup_error_text">
              <p>
              Some fields have not been filled in. Please check and fill in the fields.
              </p>
              <ul>
                {error.map((item, idx) => (
                  <li key={`${item}-${idx}`}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="popup_error_button">
              <button onClick={closePopup}>Back To Customize</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default MtmConfirm;
